var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-main',{staticClass:"page"},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('yaml-editor',{staticClass:"editor-container"})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }